<template>
  <div
    class="ai-question-type-picker d-flex flex-column row-gap-3"
    data-locator="question-type-picker"
  >
    <div class="d-flex flex-column ga-4">
      <div
        v-for="item in typeItems"
        :key="item.type"
        class="type-card clickable"
        :data-locator="item.locator"
        @click="select(item.type)"
      >
        <div class="d-flex align-center column-gap-4">
          <img
            :src="getTypeImage(item.type)"
            height="40"
            width="40"
            :alt="item.alt"
          />
          <div>
            <div class="font-weight-bold">
              {{ $t(`${TRANSLATION_KEY_PREFIX}.${item.i18nKey}.title`) }}
            </div>
            <div class="text--x-small subtitle-case">
              {{ $t(`${TRANSLATION_KEY_PREFIX}.${item.i18nKey}.subtitle`) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { AIAssistantQuestionTypes } from '@/types/ai-assistant'

const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantQuestionTypePicker'

const emit = defineEmits<(e: 'select',
  value: typeof AIAssistantQuestionTypes[keyof typeof AIAssistantQuestionTypes]
) => void>()

const selected = ref<string | null>(null)

const typeItems = computed(() => [
  {
    type: AIAssistantQuestionTypes.ASK_DOC,
    locator: 'question-type-ask-doc',
    i18nKey: 'askDoc',
    alt: 'ask-doc',
  },
  {
    type: AIAssistantQuestionTypes.ASK,
    locator: 'question-type-ask',
    i18nKey: 'ask',
    alt: 'ask',
  },
])

function select(value: typeof AIAssistantQuestionTypes[keyof typeof AIAssistantQuestionTypes]) {
  selected.value = value
  emit('select', value)
}

function getTypeImage(type: string) {
  return new URL(
    `../../assets/img/ai-assistant/question-type-${type.toLowerCase()}.svg`,
    import.meta.url,
  ).href
}
</script>

<style scoped lang="scss">
.ai-question-type-picker {
  .type-card {
    border: 1px solid #DFE3E8;
    border-radius: 8px;
    padding: 12px;
    background-color: white;
    transition: all 0.15s ease;

    &:hover {
      background-color: #F7F9FA;
    }

    .subtitle-case {
      color: #2A476A;
    }
  }
}
</style>
